import React, { useState } from "react";
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  IconButton,
  Collapse,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const format = (val) =>
  `₱${(val || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;

const percentDiff = (prev, curr) => {
  if (!prev) return "—";
  const diff = ((curr - prev) / prev) * 100;
  const arrow = diff > 0 ? "↑" : diff < 0 ? "↓" : "→";
  const color = diff > 0 ? "green" : diff < 0 ? "red" : "gray";
  return (
    <span style={{ color }}>
      {arrow} {Math.abs(diff).toFixed(2)}%
    </span>
  );
};

const SalesPopularMenuPerCategory = ({
  data,
  start,
  end,
  prevStart,
  prevEnd,
}) => {
  const popularPerCategory = data?.popularPerCategory || [];
  const mostPopularItems = data?.mostPopularItems || [];

  const [openCategories, setOpenCategories] = useState({});

  const toggleCategory = (cat) => {
    setOpenCategories((prev) => ({ ...prev, [cat]: !prev[cat] }));
  };

  return (
    <Paper sx={{ mt: 4, p: 2 }}>
      <Typography variant="h6" gutterBottom align="center">
        Sales per Category (Quantity and Amount)
      </Typography>
      <Typography
        variant="subtitle2"
        align="center"
        color="text.secondary"
        gutterBottom
      >
        {prevStart.format("MM/DD")}–{prevEnd.format("MM/DD")} vs{" "}
        {start.format("MM/DD")}–{end.format("MM/DD")}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Category</TableCell>
            <TableCell align="right">Qty (Prev)</TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="right">Qty (Curr)</TableCell>
            <TableCell align="right">Amount (Prev)</TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="right">Amount (Curr)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...popularPerCategory]
            .sort((a, b) => (b.qty?.current || 0) - (a.qty?.current || 0))
            .map((cat) => {
              const itemsInCategory = mostPopularItems
                .filter((i) => i.category === cat.name)
                .sort(
                  (a, b) => (b.amount?.current || 0) - (a.amount?.current || 0)
                );

              return (
                <React.Fragment key={cat.name}>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <IconButton
                        size="small"
                        onClick={() => toggleCategory(cat.name)}
                      >
                        {openCategories[cat.name] ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </IconButton>
                    </TableCell>
                    <TableCell>{cat.name}</TableCell>
                    <TableCell align="right">
                      {cat.qty?.previous || 0}
                    </TableCell>
                    <TableCell align="center">
                      {percentDiff(cat.qty?.previous, cat.qty?.current)}
                    </TableCell>
                    <TableCell align="right">{cat.qty?.current || 0}</TableCell>
                    <TableCell align="right">
                      {format(cat.amount?.previous)}
                    </TableCell>
                    <TableCell align="center">
                      {percentDiff(cat.amount?.previous, cat.amount?.current)}
                    </TableCell>
                    <TableCell align="right">
                      {format(cat.amount?.current)}
                    </TableCell>
                  </TableRow>

                  {openCategories[cat.name] &&
                    itemsInCategory.map((item) => (
                      <TableRow key={item.name}>
                        <TableCell />
                        <TableCell sx={{ pl: 4 }}>{item.name}</TableCell>
                        <TableCell align="right">
                          {item.qty?.previous || 0}
                        </TableCell>
                        <TableCell align="center">
                          {percentDiff(item.qty?.previous, item.qty?.current)}
                        </TableCell>
                        <TableCell align="right">
                          {item.qty?.current || 0}
                        </TableCell>
                        <TableCell align="right">
                          {format(item.amount?.previous)}
                        </TableCell>
                        <TableCell align="center">
                          {percentDiff(
                            item.amount?.previous,
                            item.amount?.current
                          )}
                        </TableCell>
                        <TableCell align="right">
                          {format(item.amount?.current)}
                        </TableCell>
                      </TableRow>
                    ))}
                </React.Fragment>
              );
            })}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default SalesPopularMenuPerCategory;
